import React from "react";

// react-router
import { Outlet } from "react-router-dom";

// Partials
import HeaderStyle1 from "../../components/partials/backend/HeaderStyle/HeaderStyle1";
import SidebarStyle from "../../components/partials/backend/SidebarStyle/SidebarStyle";
import ImpersonationBanner from "../../components/ImpersonationBanner";

const Layout1 = () => {
  const isImpersonating = localStorage.getItem("isImpersonating") === "true";

  return (
    <>
      <ImpersonationBanner />
      <div className="wrapper" style={isImpersonating ? { paddingTop: '44px' } : {}}>
        <HeaderStyle1 />
        <SidebarStyle />
        <div className="content-page">
          <Outlet />
        </div>
      </div>
      {/* <FooterStyle /> */}
    </>
  );
};

export default Layout1;
